import React, { useEffect, useState } from "react";
import { useApi } from "../../../../../hooks/useApi";
import { Input } from "../../../../Input/Input";
import AlertModal from "../../../../Modal/AlertModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";

interface GradeAddModalProps {
  closeEvent: () => void;
  confirmEvent: (name: string) => void;
}

export default function GradeAddModal({
  closeEvent,
  confirmEvent,
}: GradeAddModalProps) {
  const [name, setName] = useState("");
  const [btnClick, setBtnClick] = useState(false);
  const [duplicateErr, setDuplicateErr] = useState(false);

  const { response, error } = useApi({
    method: "post",
    url: btnClick ? `auth` : undefined,
    data: {
      name: name + "관리자",
    },
  });

  console.log(response);
  console.log(error);

  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      confirmEvent(name);
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      setDuplicateErr(true);
    }
  }, [error]);

  return (
    <DefaultModalLayout
      modalTitle="등급 추가"
      isSmallModal={true}
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        setBtnClick(true);
      }}
      confirmBtnText="추가"
    >
      <ModalRow>
        <ModalLabel>등급 입력</ModalLabel>

        <ModalRowContentContainer>
          <Input
            placeholder="관리자 빼고 입력. 예) 일반"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </ModalRowContentContainer>
      </ModalRow>

      <>
        {duplicateErr && (
          <AlertModal
            title={`중복된 등급 이름입니다. 다시 입력해 주세요.`}
            customCancelBtn={<></>}
            btnColor="mint"
            confirmEvent={() => {
              setBtnClick(false);
              setDuplicateErr(false);
            }}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}
